module.exports = __webpack_public_path__ + "img/banner.9fb42575.png";